import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgSpeaker(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.5248 3.86552C17.967 4.07005 18.25 4.51284 18.25 5.00002L18.25 27C18.25 27.4872 17.967 27.93 17.5248 28.1345C17.0826 28.3391 16.5619 28.2681 16.1906 27.9526L9.54068 22.3026H4C3.30964 22.3026 2.75 21.7429 2.75 21.0526L2.75 10.9473C2.75 10.2569 3.30964 9.6973 4 9.6973H9.54069L16.1907 4.04741C16.5619 3.73198 17.0826 3.66098 17.5248 3.86552ZM15.75 7.70227L10.8093 11.8999C10.5834 12.0919 10.2965 12.1973 10 12.1973L5.25 12.1973L5.25 19.8026H10C10.2965 19.8026 10.5834 19.908 10.8094 20.1L15.75 24.2977L15.75 7.70227Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M21.0308 9.23254L21.8991 10.1317C25.0335 13.3775 25.0335 18.6226 21.8991 21.8684L21.0308 22.7675L19.2324 21.0309L20.1007 20.1317C22.2996 17.8547 22.2996 14.1454 20.1007 11.8684L19.2324 10.9692L21.0308 9.23254Z"
      />
      <path
        fill="currentColor"
        d="M24.8765 5.10892L23.9854 4.2323L22.2322 6.01448L23.1233 6.8911C27.9588 11.648 27.9588 19.352 23.1233 24.1089L22.2322 24.9855L23.9854 26.7677L24.8765 25.8911C30.7077 20.1546 30.7077 10.8454 24.8765 5.10892Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSpeaker);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
